import AutoResizeTextarea from './AutoResizeTextarea';

export default AutoResizeTextarea;